/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DocumentStructure
 */
export interface DocumentStructure {
    /**
     * 
     * @type {number}
     * @memberof DocumentStructure
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentStructure
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStructure
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentStructure
     */
    'category'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentStructure
     */
    'type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentStructure
     */
    'yearDiff'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentStructure
     */
    'target'?: DocumentStructureTargetEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentStructure
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStructure
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStructure
     */
    'updated_at'?: string;
}

export const DocumentStructureTargetEnum = {
    Personal: 'personal',
    Family: 'family'
} as const;

export type DocumentStructureTargetEnum = typeof DocumentStructureTargetEnum[keyof typeof DocumentStructureTargetEnum];


